import React from "react";
import { useTranslation } from "react-i18next";

const Howitworks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      num: "1",
      title: t("Sign up free"),
      desc: t(
        "Download the app or open the web dashboard. Create your store in 60 seconds."
      ),
    },
    {
      num: "2",
      title: t("Add products"),
      desc: t(
        "Bulk-import an Excel sheet, scan barcodes, or use our 500K+ Egyptian product catalog."
      ),
    },
    {
      num: "3",
      title: t("Connect printer"),
      desc: t(
        "Pair any thermal Bluetooth printer in seconds. Cash drawer and scanner optional."
      ),
    },
    {
      num: "4",
      title: t("Start selling"),
      desc: t(
        "Open shift, scan, print receipt, see your numbers update live. That's it."
      ),
    },
  ];

  return (
    <section id="how-it-works" className="py-8 md:py-16 scroll-mt-32">
      <div className="container mx-auto px-4">
        {/* Section Head */}
        <div className="mx-auto mb-6 sm:mb-14 max-w-3xl text-center">


          <h2 className="mb-3 text-[clamp(28px,3.6vw,44px)] font-black leading-[1.12] tracking-normal text-gray-900">
            {t("Up and running in 10 minutes")}
          </h2>

          <p className="text-[17px] leading-relaxed text-gray-500">
            {t(
              "No technician visit. No long onboarding. Sign up, add your products, start selling."
            )}
          </p>
        </div>

        {/* Steps */}
        <div className="grid gap-1 sm:gap-4 md:gap-5 md:grid-cols-2 lg:grid-cols-4">
          {steps.map((step, index) => (
            <div
              key={index}
              className="rounded-2xl p-3 sm:p-6 text-center transition-all duration-300"
            >
              {/* Number */}
              <div className="mx-auto mb-4 sm:mb-[18px] grid h-10 w-10 sm:h-[50px] sm:w-[50px] place-items-center rounded-full bg-primaryBlue text-[18px] sm:text-[20px] font-extrabold text-white shadow-[0_6px_16px_rgba(30,64,175,.3)]">
                {step.num}
              </div>

              {/* Title */}
              <h3 className="mb-2 text-[16px] sm:text-[17px] font-bold text-gray-900">
                {step.title}
              </h3>

              {/* Description */}
              <p className="text-[14px] leading-6 sm:leading-7 text-gray-600">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Howitworks;